import { render, staticRenderFns } from "./DescricaoLivro.vue?vue&type=template&id=8caf1c2e&scoped=true&"
import script from "./DescricaoLivro.vue?vue&type=script&lang=js&"
export * from "./DescricaoLivro.vue?vue&type=script&lang=js&"
import style0 from "./DescricaoLivro.vue?vue&type=style&index=0&id=8caf1c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf1c2e",
  null
  
)

component.options.__file = "DescricaoLivro.vue"
export default component.exports